import api from 'components/Apis/axiosAPI';


export const BillingStatsApi = {
    getBillingPeriodOptions: () => api.get('billing-stats/billing-period-options/'),

    getBillingPeriod: (id) => api.get(`billing-stats/${id}/`),
    getCurrentQuarter: () => api.get('billing-stats/current-quarter/'),
    getPreviousWeek: () => api.get('billing-stats/previous-week/'),

    assignCustomerGoal: (periodId, payload) =>
        api.patch(`kpis/${periodId}/assign-customer-goals/`, payload),

    assignCompanyGoal: (periodId, payload) =>
        api.patch(`kpis/${periodId}/assign-company-goals/`, payload),

    assignCustomerSegmentGoal: (periodId, payload) =>
        api.patch(`kpis/${periodId}/assign-customer-segment-goals/`, payload),

    assignServiceTeamGoal: (periodId, payload) =>
        api.patch(`kpis/${periodId}/assign-service-team-goals/`, payload),

};
